import { useEffect, useState } from "react";

const HOVER_QUERY = "(hover: hover) and (pointer: fine)";

/** Gerçek hover destekleyen cihaz mı? Touch cihazlarda video önizleme oynatılmaz. */
export const useCanHover = () => {
  const [canHover, setCanHover] = useState(
    () => typeof window !== "undefined" && window.matchMedia(HOVER_QUERY).matches
  );

  useEffect(() => {
    const media = window.matchMedia(HOVER_QUERY);
    const handleChange = () => setCanHover(media.matches);
    media.addEventListener("change", handleChange);
    return () => media.removeEventListener("change", handleChange);
  }, []);

  return canHover;
};
